var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g(_vm._b({ref:"inner",class:_vm.mergedClass,scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,name){return {key:name,fn:function(data){return [_vm._t(name,null,null,data)]}}})],null,true)},'v-select',_vm.mergedAttrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }